import { useState, useEffect } from "react";
import { getJobBoardByJobID } from "services";

const useGetJobBoardByJobID = (jobID, submissionID) => {
  const [jobBoard, setJobBoard] = useState(null);
  const [jobBoardError, setJobBoardError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const doRequest = async () => {
    setIsLoading(true);

    const response = await getJobBoardByJobID(jobID, submissionID);

    if (response?.response?.data?.error) {
      setJobBoardError(response?.response?.data?.error);
    }

    setJobBoard(response.data);

    setIsLoading(false);
  };

  useEffect(() => {
    const getJobBoard = async () => await doRequest();

    getJobBoard();
  }, []);

  return { jobBoard, isLoading, jobBoardError };
};

export { useGetJobBoardByJobID };
